import React from 'react';
import BannerHeader, { Avatar, Banner } from './bannerHeader';
import { isGNC, isGN } from '../../utility/externalIntegrationUtils';
import GNCSubheader from './GNCSubheader';
import GNSubheader from './GNSubheader';
import templateData from '../../utility/getTemplateData';

const GNHeader = () => {
  const organizationName = templateData.donationName,
    purpose = templateData.charityName,
    bannerUrl = templateData.bannerUrl,
    logoUrl = templateData.logoUrl;

  return (
    <div>
      <BannerHeader type="logoBanner">
        <Banner bannerURL={bannerUrl} />
        <Avatar logoURL={logoUrl} />
      </BannerHeader>
      {isGNC() && (
        <GNCSubheader organizationName={organizationName} purpose={purpose} />
      )}
      {isGN() && (
        <GNSubheader organizationName={organizationName} purpose={purpose} />
      )}
    </div>
  );
};

export default GNHeader;
